import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppActionCreators } from './new-design/redux/actions/creators';
import { AsyncActionStatus } from './new-design/redux/enums';
import { AppSelectors } from './new-design/redux/selectors';
import { requestStatusCheckers } from './new-design/redux/helpers';
// import { hubspotChatIntegration } from './helpers/hubspotChatHelper';
import {
  Toast, AppLoader, HotjarInit, ChatbaseInit,
} from './new-design/views/components';
import { AppRouter } from './new-design/router';

const App = () => {
  const dispatch = useDispatch();
  const appRequestStatus = useSelector(AppSelectors.selectRequestStatus);

  useEffect(
    () => {
      dispatch(AppActionCreators.initApp[AsyncActionStatus.PENDING]());

      // hubspotChatIntegration();
    },
    [dispatch],
  );

  if (!requestStatusCheckers.isSucceeded(appRequestStatus) && !requestStatusCheckers.isFailed(appRequestStatus)) {
    return <AppLoader />;
  }

  return (
    <>
      <AppRouter />
      <Toast />
      <HotjarInit />
      <ChatbaseInit />
    </>
  );
};

export default App;
